import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// Russian
import ruCommon from './locales/ru/common.json'
import ruWorker from './locales/ru/worker.json'
import ruGamification from './locales/ru/gamification.json'
import ruAdmin from './locales/ru/admin.json'

// English
import enCommon from './locales/en/common.json'
import enWorker from './locales/en/worker.json'
import enGamification from './locales/en/gamification.json'
import enAdmin from './locales/en/admin.json'

// Uzbek
import uzCommon from './locales/uz/common.json'
import uzWorker from './locales/uz/worker.json'
import uzGamification from './locales/uz/gamification.json'
import uzAdmin from './locales/uz/admin.json'

i18n.use(initReactI18next).init({
  resources: {
    ru: {
      common: ruCommon,
      worker: ruWorker,
      gamification: ruGamification,
      admin: ruAdmin,
    },
    en: {
      common: enCommon,
      worker: enWorker,
      gamification: enGamification,
      admin: enAdmin,
    },
    uz: {
      common: uzCommon,
      worker: uzWorker,
      gamification: uzGamification,
      admin: uzAdmin,
    },
  },
  lng: 'ru',
  fallbackLng: 'ru',
  defaultNS: 'common',
  ns: ['common', 'worker', 'gamification', 'admin'],
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
